var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCalendar = function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 12a1 1 0 0 1 1-1h2.625a1 1 0 0 1 .78 1.625l-.669.836a2.5 2.5 0 1 1-3.378 3.68 1 1 0 1 1 1.416-1.413.499.499 0 1 0 .353-.853 1 1 0 0 1-.783-1.625l.2-.25H8.25a1 1 0 0 1-1-1M16.375 12a1 1 0 0 0-1.6-.8l-1.5 1.125a1 1 0 0 0 1.1 1.666v2.884a1 1 0 1 0 2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.5 1.875a1 1 0 1 0-2 0v.875h-7v-.875a1 1 0 0 0-2 0v.875h-2A1.75 1.75 0 0 0 2.75 4.5v15c0 .966.784 1.75 1.75 1.75h15a1.75 1.75 0 0 0 1.75-1.75v-15a1.75 1.75 0 0 0-1.75-1.75h-2zm1.75 5.375v-2.5H4.75v2.5zm-14.5 2h14.5v10H4.75z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconCalendar;